import React from "react";
import { FaFilter, FaSearch, FaTimes } from "react-icons/fa";

function CoachGradeFilters({
  groups = [],
  belts = [],
  filters,
  onChange,
  onReset,
}) {
  return (
    <section className="rounded-[2rem] border border-white/80 bg-white/95 p-4 shadow-2xl shadow-slate-200/70 backdrop-blur-xl dark:border-white/10 dark:bg-slate-900/95 dark:shadow-black/30 sm:p-5">
      <div className="flex items-center justify-between gap-3">
        <div>
          <div className="inline-flex items-center gap-2 rounded-full bg-sky-100 px-3 py-2 text-xs font-bold uppercase tracking-[0.16em] text-sky-700 dark:bg-sky-500/10 dark:text-sky-200">
            <FaFilter />
            Filtres
          </div>

          <h2 className="mt-3 font-titre text-xl font-bold text-slate-950 dark:text-white">
            Rechercher un judoka
          </h2>
        </div>

        <button
          type="button"
          onClick={onReset}
          className="inline-flex min-h-10 items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-3 py-2 text-xs font-bold text-slate-600 transition hover:border-red-200 hover:text-red-600 dark:border-white/10 dark:bg-white/[0.05] dark:text-white/70"
        >
          <FaTimes />
          Reset
        </button>
      </div>

      <div className="mt-5 grid gap-3 lg:grid-cols-[1.4fr_0.8fr_0.8fr]">
        <label className="relative block">
          <FaSearch className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />

          <input
            type="search"
            value={filters.search}
            onChange={(event) => onChange("search", event.target.value)}
            placeholder="Nom, prénom, club..."
            className="h-12 w-full rounded-2xl border border-slate-200 bg-slate-50 pl-11 pr-4 text-sm font-bold text-slate-700 outline-none transition placeholder:text-slate-400 focus:border-sky-300 focus:bg-white focus:ring-4 focus:ring-sky-100 dark:border-white/10 dark:bg-slate-950 dark:text-white dark:focus:border-sky-300/50 dark:focus:ring-sky-500/10"
          />
        </label>

        <select
          value={filters.groupId}
          onChange={(event) => onChange("groupId", event.target.value)}
          className="h-12 rounded-2xl border border-slate-200 bg-slate-50 px-4 text-sm font-bold text-slate-700 outline-none transition focus:border-sky-300 focus:bg-white focus:ring-4 focus:ring-sky-100 dark:border-white/10 dark:bg-slate-950 dark:text-white dark:focus:border-sky-300/50 dark:focus:ring-sky-500/10"
        >
          <option value="">Tous les groupes</option>
          {groups.map((group) => (
            <option key={group.id} value={group.id}>
              {group.nom}
            </option>
          ))}
        </select>

        <select
          value={filters.beltId}
          onChange={(event) => onChange("beltId", event.target.value)}
          className="h-12 rounded-2xl border border-slate-200 bg-slate-50 px-4 text-sm font-bold text-slate-700 outline-none transition focus:border-sky-300 focus:bg-white focus:ring-4 focus:ring-sky-100 dark:border-white/10 dark:bg-slate-950 dark:text-white dark:focus:border-sky-300/50 dark:focus:ring-sky-500/10"
        >
          <option value="">Toutes les ceintures</option>
          {belts.map((belt) => (
            <option key={belt.id} value={belt.id}>
              {belt.nom}
            </option>
          ))}
        </select>
      </div>
    </section>
  );
}

export default CoachGradeFilters;